import { ChangeEvent, Dispatch, SetStateAction, useCallback, useState } from 'react'

type UseHandleAllergens = {
  allergens: string[]
  isSetAllergens: boolean
  handleAllergens: (event: ChangeEvent<HTMLInputElement>) => void
  handleSetAllergens: (event: ChangeEvent<HTMLInputElement>) => void
  setAllergens: Dispatch<SetStateAction<string[]>>
  setIsSetAllergens: Dispatch<SetStateAction<boolean>>
}

const useHandleAllergens = (): UseHandleAllergens => {
  const [allergens, setAllergens] = useState<string[]>(['wheat'])
  const [isSetAllergens, setIsSetAllergens] = useState<boolean>(true)
  const handleAllergens = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setAllergens((prevState) => {
        // 選択済みの値であれば削除
        if (prevState.some((state) => state === event.target.id)) {
          return prevState.filter((state) => state !== event.target.id)
        } else {
          setIsSetAllergens(true)
          return [...prevState, event.target.id]
        }
      })
    },
    [setAllergens, setIsSetAllergens]
  )
  const handleSetAllergens = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.value === 'set') {
        setIsSetAllergens(true)
      } else {
        setAllergens([])
        setIsSetAllergens(false)
      }
    },
    [setIsSetAllergens, setAllergens]
  )
  return {
    allergens,
    isSetAllergens,
    handleAllergens,
    handleSetAllergens,
    setAllergens,
    setIsSetAllergens,
  }
}

export default useHandleAllergens
